angular.module('rjmNg.services').factory 'persistentViewsService', [
  '$http'
  '$modal'
  '$q'
  '$rootScope'
  'serviceUrl'
  'app'
  'remoteDBConnectionService'
  ($http, $modal, $q, $rootScope, serviceUrl, app, remoteDBConnectionService) ->

    httpArgs = (id = null) ->
      url = if id? then serviceUrl("/clients/#{app.getClientId()}/views/#{id}") else serviceUrl("/clients/#{app.getClientId()}/views")
      {
        url: url
        headers: {'Content-Type': 'application/json'}
        withCredentials: true
      }

    connectionId = 'views'

    persistentViewsService = {}

    persistentViewsService.save = (toSave) ->
      deferred = $q.defer()
      $http(angular.extend httpArgs(),
        method: 'POST'
        data: toSave
      )
      .then ({data}) ->
        deferred.resolve(data)
      .catch (error) ->
        deferred.reject(error)
      deferred.promise

    persistentViewsService.get = (id) ->
      deferred = $q.defer()
      args = httpArgs()
      if(id?)
        args = httpArgs(id)
      $http(angular.extend args,
        method: 'GET'
      )
      .then ({data}) ->
        deferred.resolve(data)
      .catch (error) ->
        deferred.reject(error)
      deferred.promise

    persistentViewsService.update = (view) ->
      deferred = $q.defer()
      $http(angular.extend httpArgs(view.id),
        method: 'PUT'
        data: view
      )
      .then ({data}) ->
        deferred.resolve(data)
      .catch (error) ->
        deferred.reject(error)
      deferred.promise

    persistentViewsService.getViewSchema = () ->
      deferred = $q.defer()
      $http(angular.extend httpArgs(),
        url: serviceUrl("/clients/#{app.getClientId()}/tables?type=view")
        method: 'GET'
      )
      .then ({data}) ->
        deferred.resolve(data)
      .catch (error) ->
        deferred.reject(error)
      deferred.promise

    _getSchemaByName = (name) ->
      deferred = $q.defer()
      persistentViewsService.getViewSchema().then((result) ->
        found = _.find(result, (schema) ->
          schema.name is name
        )
        if found?
          deferred.resolve found
        else
          deferred.reject "Couldn't find #{name}"
      , (error) ->
        deferred.reject error
      )
      deferred.promise

    _getColumns = (view) ->
      deferred = $q.defer()
      if view.schema?.id?
        $http(angular.extend httpArgs(),
          url: serviceUrl("/clients/#{app.getClientId()}/columns?tid=#{view.schema.id}")
        )
        .then ({data}) ->
          deferred.resolve data
        .catch (error) ->
          deferred.reject error
      else
        deferred.reject "_attachColumns tableId is undefined"
      deferred.promise

    persistentViewsService.attachSchema = (view) ->
      viewWithSchema = view
      deferred = $q.defer()
      _getSchemaByName(view.name).then((schema) ->
        viewWithSchema.schema = schema
        deferred.resolve viewWithSchema
      , (error) ->
        deferred.reject error
      )
      deferred.promise

    persistentViewsService.deleteView = ({id}) ->
      deferred = $q.defer()
      $http(angular.extend httpArgs(id),
        method: 'DELETE'
      )
      .then ({data}) ->
        deferred.resolve(data)
      .catch (error) ->
        deferred.reject(error)
      deferred.promise

    _deleteRemoteDBConnection = (view, force, preview) ->
      _getColumns(view).then((columns) ->
        remoteDBConnectionService.save(
          view.schema.id
          columns
          app.getClientId()
          null    # tableRowCount
          null    # totalTrackedRows
          force   # ignoreDependencies
          true    # dropTable
          preview # preview
          true    # isView
        )
      , (error) ->
        console.log(error)
      )

    persistentViewsService.attemptDropViewTable = (view) ->
      deferred = $q.defer()
      _deleteRemoteDBConnection(view, false, true).then((result) ->
        deferred.resolve result.data
      , (error) ->
        deferred.reject error
      )
      deferred.promise

    persistentViewsService.forceDropViewTable = (view) ->
      deferred = $q.defer()
      _deleteRemoteDBConnection(view, true, false).then((result) ->
        persistentViewsService.deleteView(view).then((result) ->
          deferred.resolve result.data
        , (error) ->
          deferred.reject error
        )
      , (error) ->
        deferred.reject error
      )
      deferred.promise

    persistentViewsService.addToDWMList = (data, rsConnections) ->
      rsConnectionObj =
        name: 'Data Warehouse Views'
        id: connectionId
        type: 'persistent_view'
        rsDatabases:
          persistent_view:
            name: 'Data Warehouse Views'
            rsSchemas:
              '':
                name: ''
                rsTables: {}
      addView = (v) ->
        rsConnectionObj.rsDatabases.persistent_view.rsSchemas[''].rsTables[v.name] =
          isView: true
          id: v.id
          fullName: v.name
          name: v.name
          databaseName: 'persistent_view'
          connectionId: connectionId
          schema: 'emptySchema'
          trackedColor: 1
          replicator:
            type: 'persistentview'

      data.sort (a, b) ->
        a.name.localeCompare b.name

      for view in data
        addView(view)

      rsConnections[connectionId] = rsConnectionObj

    persistentViewsService.isView = (id) ->
      id is connectionId

    persistentViewsService.showDeleteModal = (view, deleteFn) ->
      modalScope = $rootScope.$new()
      modalScope.persistentView = view

      modalScope.confirmDelete = (modal) ->
        modal('hide')
        deleteFn()

      modal = $modal(
        template: 'modal.deletePersistentView.html'
        show: true
        backdrop: 'static'
        keyboard: false
        scope: modalScope
        priority: 10
        modalClass: 'rj-modal'
      )

    persistentViewsService
]
